import { useEffect, useState } from 'react';
// @ts-ignore
import styles from './RadioListOld.module.scss';
import Text from '../../Base/Text/Text';
import { joinClasses } from '../../../Utils/className.util';
import Label from '../Label/Label';
import * as React from 'react';
import Tooltip from '../../Popup/Tooltip';
import { FieldError } from 'react-hook-form';
import { useValidation } from '../../Utils/Validation';

interface RadioListProps {
	data: RadioListItem[];
	value?: string | number;
	onChange?: any;
	inLine?: boolean;
	firstUpper?: boolean;
	titleClassName?: any;
	error?: FieldError;
	disabled?: boolean;
}

export interface RadioListItem {
	title: string;
	value: string | boolean;
	text?: string;
	settings?: RadioListItemSettings;
}

interface RadioListItemSettings {
	tooltip: {
		content: any;
	};
}

const RadioList: React.FC<RadioListProps> = props => {
	const { data, onChange, inLine = false, titleClassName, disabled } = props;
	const { value = null } = props;
	const [checked, setChecked] = useState(value);
	const { fillErrorMessage } = useValidation();

	useEffect(() => {
		if (!disabled) {
			setChecked(value);
		}
	}, [value]);

	const handleClick = (item: RadioListItem) => {
		if (!disabled) {
			setChecked(item.value);
			onChange(item.value);
		}
	};

	return (
		<>
			<div
				className={joinClasses([
					styles.wrapper,
					disabled ? styles.disabled : '',
					inLine ? styles.inLine : '',
					props.error ? styles.invalid : '',
				])}>
				{data.map((item: RadioListItem, index) => (
					<div
						key={index}
						className={styles.radioWrapper}
						onClick={() => handleClick(item)}>
						<div
							className={`${styles.radio} ${
								item.value == checked && styles.active
							}`}
						/>
						<div
							style={{
								display: 'block',
								flexDirection: 'row',
								gap: '6px',
								alignItems: 'center',
							}}>
							<Text
								className={joinClasses([titleClassName, styles.title])}
								tx={item.title}
								inline={true}
								firstUpper
							/>
							{item?.settings?.tooltip && (
								<Tooltip
									trigger={
										<img
											alt={'info'}
											className='ml-2'
											width='20px'
											src='/dist/icons/v2/circle-info-solid.svg'
										/>
									}
									customStyle={{ display: 'inline-block' }}>
									<Text tx={item.settings.tooltip.content} inline={true} />
								</Tooltip>
							)}
						</div>
					</div>
				))}
			</div>
			{props.error && (
				<div className={styles.errorMessage}>
					<Text tx={fillErrorMessage(props.error)} inline={true} />
				</div>
			)}
		</>
	);
};

export default RadioList;
